import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { SEPARATOR_HEIGHT } from "../SubtaskSeparator/styles";

export default makeStyles((theme) => ({
  root: {
    "& div:last-child $body": {
      borderBottom: "none",
      width: "100%",
    },
  },
  item: {
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // Same hook as `DraggableList`: a tinted host (the Library drawer) sets it
    // to `transparent`, everywhere else the row stays white.
    background: "var(--draggable-item-background, white)",
    borderRadius: theme.spacing(1),
  },
  body: {
    width: "100%",
    height: "100%",
  },
  separatorContainer: {
    width: "100%",
  },
  cursor: {
    cursor: "move",
    width: 48,
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "&:active svg": {
      color: grey[800],
    },

    "& svg": {
      color: grey[500],
      transition: "color .3s",
    },
  },
  subTasks: {
    padding: 0,
    transition: "height 0.3s ease",
    "& div:last-child": {
      borderBottom: "none",
    },
  },
  draggbleContainer: {
    overflow: "hidden",
    "&:hover .separator": {
      height: SEPARATOR_HEIGHT,
    },
  },
  subTask: {
    padding: "13.5px 8px",
  },
  subTaskText: {
    fontSize: 14,
    fontWeight: 400,
  },
  lineThrough: {
    textDecoration: "line-through",
  },
  conditionalIcon: {
    // Hugs the title text. Inline-flex + middle keeps the svg vertically
    // centred against the 14px text; plain span — no button/ripple.
    display: "inline-flex",
    alignItems: "center",
    marginLeft: theme.spacing(1),
    verticalAlign: "middle",
  },
  listItemBox: {
    margin: 0,
  },
  optionTaskText: {
    textAlign: "right",
    fontSize: 12,
    color: grey[600],
    lineHeight: 1.5,
    fontWeight: 400,
  },
  listItemDivider: {
    marginLeft: 56,
    "&:last-child": {
      display: "none",
    },
  },
}));
